import { render, staticRenderFns } from "./editruleForm.vue?vue&type=template&id=6b5c0b43&"
import script from "./editruleForm.vue?vue&type=script&lang=js&"
export * from "./editruleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports